import { render } from "./Footer.vue?vue&type=template&id=5319a879&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=5319a879&scoped=true&lang=css"

import exportComponent from "D:\\nawarat-libya\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5319a879"]])

export default __exports__